export const environment = {
  production: true,
  services: {
    oktaForgotPasswordUrl: 'https://forgotpwd.idm.bwhhotelgroup.com/production/',
    idmAppUrl: 'https://hotelsso.bwhhotelgroup.com/',
    resetPasswordUrl: 'bwhhghotels.okta.com',
  },
};
